import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface ScrollToTopProps {
  scrollElement?: HTMLElement | null;
}

export default function ScrollToTop({ scrollElement }: ScrollToTopProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (scrollElement?.scrollTo) {
      scrollElement.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, scrollElement]);

  return null;
}
